// if (window.innerWidth > 1000) {
    const buttons = document.querySelectorAll('button[id^="tab-"]');
    const contents = document.querySelectorAll('div[id^="content-"]');

    // Ensure content-one has active-content and tab-one has active-tab on load
    document.getElementById('content-one').classList.add('active-content');
    document.getElementById('tab-one').classList.add('active-tab');

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            const num = button.id.split('-')[1];
            // Remove active-content from all contents
            contents.forEach(content => content.classList.remove('active-content'));
            // Remove active-tab from all buttons
            buttons.forEach(btn => btn.classList.remove('active-tab'));
            // Add to the corresponding content
            document.getElementById('content-' + num).classList.add('active-content');
            // Add to the clicked button
            button.classList.add('active-tab');
        });
    });
// }

const toggleButtons = document.querySelectorAll('.questions_toggle');
toggleButtons.forEach(toggle => {
    toggle.addEventListener('click', () => {
        const wrapper = toggle.closest('.questions_toggle_wrapper');
        if (!wrapper) return;
        wrapper.classList.toggle('questions_toggle_active');
    });
});